import * as React from 'react';
import { createMasonryInstance, driver } from '@leagueplatform/masonry';
import { MasonryEngineEvent } from '@leagueplatform/masonry-engine';
import { DASHBOARD_MASONRY_HANDLERS } from '../../../node-handlers';

export const ABOUT_ME_METRIC_DETAILS_ROOT_NODE_ID = 'aboutMeMetricDetails$root';

type UseAboutMeMetricDetailsMasonryEngineInstanceParams = {
  metricType: string;
  onAddDataClick: () => void;
  onConnectDeviceClick: () => void;
};

export function useAboutMeMetricDetailsMasonryEngineInstance({
  metricType,
  onAddDataClick,
  onConnectDeviceClick,
}: UseAboutMeMetricDetailsMasonryEngineInstanceParams) {
  React.useEffect(() => {
    const unsubscribePrimaryCta = driver.actionController.addEventListener(
      'deeplink',
      DASHBOARD_MASONRY_HANDLERS.DASHBOARD_METRIC_DETAILS_EMPTY_STATE_PRIMARY_CTA,
      MasonryEngineEvent.ALL,
      onAddDataClick,
    );

    const unsubscribeSecondaryCta = driver.actionController.addEventListener(
      'deeplink',
      DASHBOARD_MASONRY_HANDLERS.DASHBOARD_METRIC_DETAILS_EMPTY_STATE_SECONDARY_CTA,
      MasonryEngineEvent.ALL,
      onConnectDeviceClick,
    );
    return () => {
      unsubscribePrimaryCta();
      unsubscribeSecondaryCta();
    };
  }, [onAddDataClick, onConnectDeviceClick]);

  return React.useMemo(() => {
    const { Component, invokeAction } = createMasonryInstance();
    return {
      invokeAction,
      Component: () => (
        <Component
          rootNodeId={ABOUT_ME_METRIC_DETAILS_ROOT_NODE_ID}
          initialQueryParams={{ metricType }}
        />
      ),
    };
  }, [metricType]);
}
